import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class GetMakeModelFaqsRequest extends ValueObject {
  #context
  #make
  #makeId
  #model
  #modelId
  #path

  static validate({make, makeId, model, modelId, path}) {
    if (!makeId || !make || !path) {
      throw InvalidParamsSharedError.create(`[GetMakeModelFaqsRequest.validate] param makeId, make, path are required`)
    }
  }

  constructor({context, make, makeId, model, modelId, path}) {
    super()
    this.#context = context
    this.#make = make
    this.#makeId = makeId
    this.#model = model
    this.#modelId = modelId
    this.#path = path
  }

  static create({context, make, makeId, model, modelId, path}) {
    GetMakeModelFaqsRequest.validate({make, makeId, model, modelId, path})
    return new GetMakeModelFaqsRequest({
      context,
      make,
      makeId,
      model,
      modelId,
      path
    })
  }

  toJSON() {
    return {
      context: this.#context,
      make: this.#make,
      makeId: this.#makeId,
      model: this.#model,
      modelId: this.#modelId,
      path: this.#path
    }
  }
}
